import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { MoviesComponent } from './pages/movies/movies.component';
import { MovieDetailComponent } from './pages/movie-detail/movie-detail.component';
import { CinemasComponent } from './pages/cinemas/cinemas.component';
import { CinemaDetailComponent } from './pages/cinema-detail/cinema-detail.component';
import { AdminScrapeComponent } from './pages/admin-scrape/admin-scrape.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'movies', component: MoviesComponent },
  { path: 'movies/:id', component: MovieDetailComponent },
  { path: 'cinemas', component: CinemasComponent },
  { path: 'cinemas/:id', component: CinemaDetailComponent },
  { path: 'admin/scrape', component: AdminScrapeComponent },
];
